import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import pinImage from '../images/pin.png';
import pinActiveImage from '../images/pin-active.png';
import AnalyticsService from '../../shared/services/AnalyticsService';

import ProviderWebsiteLink from './ProviderWebsiteLink';

export const pageOfResult = (displayIndex, resultsLimit) => Math
  .floor((displayIndex - 1) / resultsLimit);

/* eslint-disable camelcase */
function PinnedLocation(props) {
  const {
    id,
    name,
    website,
    location,
    resultsLimit,
    displayIndex,
    practice_name,
    hoveredResultId,
    selectedResultId,
    setUserCoordinates,
    openResultInfoWindow,
    setPage,
    setHoveredResultId,
    setSelectedResultId,
  } = props;

  const { t } = useTranslation();

  /* eslint-disable eqeqeq */
  const idEqualToSelectedResultId = id == selectedResultId;
  const pinActive = idEqualToSelectedResultId || hoveredResultId == id;
  /* eslint-enable eqeqeq */

  return (
    <div className={`map-marker ${idEqualToSelectedResultId ? 'map-marker--opened' : ''} ${pinActive ? 'map-marker--active' : ''}`}>
      <section
        className='map-marker__pin'
        role='button'
        tabIndex='0'
        onMouseEnter={() => {
          setHoveredResultId(id);
        }}
        onMouseLeave={() => {
          setHoveredResultId(null);
        }}
        onClick={() => {
          AnalyticsService.sendClick(
            'Find a Doctor',
            `[${id}] - [${name}]`,
          );
          openResultInfoWindow(location.id);
          const { latitude, longitude } = location;
          setUserCoordinates({ latitude, longitude });
          setSelectedResultId(id);
          setPage(pageOfResult(displayIndex, resultsLimit));
        }}
      >
        <img
          src={pinActive ? pinActiveImage : pinImage}
          alt={t('pinned_location.pin_img_alt')}
          className='map-marker__img'
        />
        <div className='map-marker__number'>
          { displayIndex }
        </div>
      </section>
      <section className='map-marker__info'>
        <button
          type='button'
          className='map-marker__close-button'
          onClick={() => {
            openResultInfoWindow();
            setSelectedResultId(null);
          }}
        >
          <span
            aria-label='close'
            className='map-marker__close-icon'
          />
        </button>
        <span className='map-marker__heading'>
          { practice_name }
        </span><br />
        { name }<br />
        { location.address }<br />
        { location.city }, { location.region } { location.postal }<br />
        { location.phone }
        {
          (location.website || website) && (
            <Fragment>
              <br />
              <ProviderWebsiteLink
                provider={{
                  id,
                  name,
                  website,
                  location,
                }}
                className='branded__link map-marker__website'
              >
                { t('provider_list.website') }
              </ProviderWebsiteLink>
            </Fragment>
          )
        }
      </section>
    </div>
  );
}

PinnedLocation.propTypes = {
  id: PropTypes.number,
  name: PropTypes.string,
  website: PropTypes.string,
  practice_name: PropTypes.string,
  hoveredResultId: PropTypes.number,
  selectedResultId: PropTypes.number,
  displayIndex: PropTypes.number.isRequired,
  setUserCoordinates: PropTypes.func.isRequired,
  openResultInfoWindow: PropTypes.func.isRequired,
  setPage: PropTypes.func.isRequired,
  setHoveredResultId: PropTypes.func.isRequired,
  setSelectedResultId: PropTypes.func.isRequired,
  location: PropTypes.shape({
    city: PropTypes.string,
    phone: PropTypes.string,
    region: PropTypes.string,
    postal: PropTypes.string,
    address: PropTypes.string,
    website: PropTypes.string,
    latitude: PropTypes.number,
    longitude: PropTypes.number,
    id: PropTypes.number.isRequired,
  }).isRequired,
  resultsLimit: PropTypes.number.isRequired,
};

export default PinnedLocation;
/* eslint-enable camelcase */
